import { createFileRoute } from '@tanstack/react-router';
import LogoAndFaviconEdit from '../../../../../packages/organization-crate/components/LogoAndFaviconEdit';

export const Route = createFileRoute('/_secured/administration/account/account-settings/o/edit-logo')({
  component: LogoAndFaviconEdit,
});
